<template>
  <div class="home">
    <Header :title="title" :showBack="false"></Header>
    <div class="main" style="padding: 0.25rem">
      <div class="head-img-box">
        <img class="head-img" src="../img/company.png" alt v-show="isShowCyw" />
      </div>
      <div style="margin-top: 4rem" v-show="!isShowCyw"></div>
      <div class="company">
        <div style="margin-bottom: 0.3rem">
          <company-change
            v-if="
              user.CompGID.toUpperCase() ==
              '7EEC93FA-C72C-44EA-8F49-9F57CD7D3451'
            "
          ></company-change>
        </div>
        <div
          class="flex flex-justify-center flex-items-center"
          style="font-size: 15px; font-family: NSimSun"
        >
          <!-- 您好！{{ user.CompName }}--{{ user.UserName }} -->
          <p style="flex: 1; margin: 0 0.3rem">
            <span class="iconfont iconqiye"></span>
            {{ getCompInfo.CompName }} - {{ user.UserName }}
          </p>
        </div>
      </div>
      <!-- <div>
      <van-button
        @click="onLoadingLine"
        v-show="isShowModel('StationManagement')"
        loading-text="加载中..."
        style="
          background-color: #555562;
          margin-top: 20px;
          font-weight: bold;
          color: #fff;
        "
        >站务管理</van-button
      >
    </div>
    <div>
      <van-button
        v-if="SeatReserveShow && isShowModel('SeatReservation')"
        @click="SeatReserve"
        loading-text="加载中..."
        style="
          background-color: #555562;
          margin-top: 20px;
          font-weight: bold;
          color: #fff;
        "
        >座位预定</van-button
      >
    </div>
    <div>
      <van-button
        @click="LineClassManagement"
        v-show="isShowModel('LineManagement')"
        loading-text="加载中..."
        style="
          background-color: #555562;
          margin-top: 20px;
          font-weight: bold;
          color: #fff;
        "
        >班线管理</van-button
      >
    </div>
    <div>
      <van-button
        @click="toVehicleManagement"
        v-show="isShowModel('CarManagement')"
        loading-text="加载中..."
        style="
          background-color: #555562;
          margin-top: 20px;
          font-weight: bold;
          color: #fff;
        "
        >车辆管理</van-button
      >
    </div>
    <div>
      <van-button
        v-if="
          edition == 'test.hd.class.busboss.cn' ||
          edition == '192.168.137.1' ||
          edition == 'localhost' ||
          user.CompGID.toUpperCase() == '7EEC93FA-C72C-44EA-8F49-9F57CD7D3451'
        "
        @click="toTestModule"
        loading-text="加载中..."
        style="
          background-color: #555562;
          margin-top: 20px;
          font-weight: bold;
          color: #fff;
        "
        >测试模块</van-button
      >
    </div> -->

      <van-grid :clickable="true" :border="false" class="grid">
        <van-grid-item
          @click="onLoadingLine"
          v-if="isShowModel('StationManagement')"
        >
          <span slot="icon">
            <van-icon name="location-o" color="#F7A33C" size="36" />
          </span>
          <span slot="text" class="grid-item-label"> 站务管理 </span>
        </van-grid-item>
        <van-grid-item
          @click="toNodeCheckManagement"
          v-if="isShowModel('NodeCheckManagement')"
        >
          <span slot="icon">
            <van-icon name="location-o" color="#F7A33C" size="36" />
          </span>
          <span slot="text" class="grid-item-label"> 站点检票 </span>
        </van-grid-item>
        <van-grid-item
          @click="toNodeCheckManagementNew"
          v-if="isShowModel('NodeCheckManagement')"
        >
          <span slot="icon">
            <van-icon name="location-o" color="#F7A33C" size="36" />
          </span>
          <span slot="text" class="grid-item-label"> 站点检票（新） </span>
        </van-grid-item>
        <van-grid-item
          v-if="SeatReserveShow && isShowModel('SeatReservation')"
          @click="SeatReserve"
        >
          <span slot="icon">
            <van-icon name="phone-o" color="#F7A33C" size="36" />
          </span>
          <span slot="text" class="grid-item-label"> 座位预定 </span>
        </van-grid-item>
        <van-grid-item
          @click="LineClassManagement"
          v-if="isShowModel('LineManagement')"
        >
          <span slot="icon">
            <van-icon name="exchange" color="#F7A33C" size="36" />
          </span>
          <span slot="text" class="grid-item-label"> 班线管理 </span>
        </van-grid-item>
        <van-grid-item
          @click="toVehicleManagement"
          v-if="isShowModel('CarManagement')"
        >
          <span slot="icon">
            <van-icon name="logistics" color="#F7A33C" size="36" />
          </span>
          <span slot="text" class="grid-item-label"> 车辆管理 </span>
        </van-grid-item>

        <van-grid-item
          @click="toTestModule"
          v-if="
            user.CompGID.toUpperCase() == '7EEC93FA-C72C-44EA-8F49-9F57CD7D3451'
          "
        >
          <span slot="icon">
            <van-icon name="gem-o" color="#F7A33C" size="36" />
          </span>
          <span slot="text" class="grid-item-label"> 测试模块 </span>
        </van-grid-item>

        <van-grid-item
          @click="toAnalysisStats"
          v-if="isShowModel('AnalysisStats')"
        >
          <template slot="icon">
            <i
              class="iconfont iconfenxi"
              style="color: #f7a33c; font-size: 0.923rem"
            ></i>
          </template>
          <span
            slot="text"
            class="grid-item-label"
            style="margin-top: 0.077rem"
          >
            统计分析
          </span>
        </van-grid-item>

        <van-grid-item
          @click="toLineTicketCheck"
          v-if="isShowModel('LineTicketCheck')"
        >
          <template slot="icon">
            <van-icon name="records" color="#F7A33C" size="36" />
          </template>
          <span
            slot="text"
            class="grid-item-label"
            style="margin-top: 0.077rem"
          >
            线路检票
          </span>
        </van-grid-item>

        <van-grid-item
          @click="toCarPoolUserDetail"
          v-if="isShowModel('CarPoolUserDetail')"
        >
          <template slot="icon">
            <van-icon name="records" color="#F7A33C" size="36" />
          </template>
          <span
            slot="text"
            class="grid-item-label"
            style="margin-top: 0.077rem"
          >
            拼车订单
          </span>
        </van-grid-item>

        <van-grid-item
          @click="toTicketConnectOrder"
          v-if="isShowModel('TicketConnectOrder')"
        >
          <template slot="icon">
            <van-icon name="records" color="#F7A33C" size="36" />
          </template>
          <span
            slot="text"
            class="grid-item-label"
            style="margin-top: 0.077rem"
          >
            接驳订单
          </span>
        </van-grid-item>

        <!-- <van-grid-item>
        <span slot="icon">
          <van-icon name="after-sale" color="#F7A33C" size="36"/>
        </span>
        <span slot="text" class="grid-item-label">
          站务费缴款
        </span>
      </van-grid-item> -->
        <!-- <van-grid-item />
      <van-grid-item/>
      <van-grid-item/> -->
        <div class="foot" v-show="isShowCyw">
          © 2019 广州市悦到信息科技有限公司
        </div>
        <div class="text-center w-full">
          <a href="https://beian.miit.gov.cn/">粤ICP备16017231号-11A</a>
        </div>
      </van-grid>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/Header/Header.vue";
import companyChange from "@/components/companyChange.vue";
export default {
  components: {
    Header,
    "company-change": companyChange,
  },
  data() {
    return {
      isShowCyw: !(window.localStorage.getItem("isShowCyw") == "false"),
      title: !this.isShowCyw ? "主页" : "车盈网",
      user: JSON.parse(window.localStorage.getItem("adminInfo")),
      SeatReserveShow: false,
      edition: location.hostname, //版本
    };
  },
  computed: {
    getCompInfo() {
      return this.$store.getters.getCompInfo;
    },
  },
  methods: {
    //判断是否显示
    isShowModel(model) {
      let isshow = this.$utils.getRight("CywPhone." + model, "IsShow" + model);
      // console.log(
      //   model +
      //     "：" +
      //     this.$utils.getRight("CywPhone." + model, "IsShow" + model)
      // );
      return isshow;
    },
    onCross() {
      this.$toast("功能开发中");
    },
    toVehicleManagement() {
      this.$router.push({
        name: "VehicleHome",
      });
    },
    toLineTicketCheck() {
      this.$router.push({
        name: "LineCheckTicket",
        params: {
          type: "linecheck",
        },
      });
    },
    toCarPoolUserDetail() {
      this.$router.push({
        name: "CarPoolUserDetail",
        params: {},
      });
    },
    toTicketConnectOrder() {
      this.$router.push({
        name: "TicketConnectOrder",
        params: {},
      });
    },
    toTestModule() {
      this.$router.push({
        name: "TestModule",
      });
    },
    onGetCompName() {
      window.localStorage.setItem(
        "CompGID",
        JSON.parse(
          window.localStorage.getItem("adminInfo")
        ).CompGID.toUpperCase()
      );
      let params = {
        GID: JSON.parse(window.localStorage.getItem("adminInfo")).CompGID,
      };
      this.$http
        .post(this.$api.getCompInfo, this.$qs.stringify(params))
        .then((res) => {
          if (res.success) {
            console.log(res);
            this.comp = res.data[0].CompFullName;
          }
        });
    },
    onLoadingLine() {
      let that = this;
      that.$router.push({ name: "LineClassDay", params: {} });
    },
    // 座位预定块
    SeatReserve() {
      //return
      this.$router.push({
        name: "LineClass",
      });
    },
    // 班线管理
    LineClassManagement() {
      // this.onCross();
      // return;
      this.$router.push({
        name: "LineClassList",
        params: {},
      });
    },
    toNodeCheckManagement() {
      this.$router.push({
        name: "NodeList",
      });
    },
    toNodeCheckManagementNew() {
      this.$router.push({
        name: "NodeListNew",
      });
    },
    toAnalysisStats() {
      this.$router.push({
        name: "AnalysisStats",
      });
    },
  },
  mounted: function () {
    //this.onGetCompName();
    if (this.$utils.getSysParams("IsHandhelShowClassSale") === "1") {
      this.SeatReserveShow = true;
    }
  },
  created() {},
};
</script>

<style scoped lang="less">
.home {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  // background-color: #fff;
}

.main {
  display: flex;
  flex: 1;
  flex-direction: column;
}

.foot {
  clear: both;
  /* 清除浮动元素格式 */
  width: 100%;
  height: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 1.44rem;
  position: relative;
  // margin-top: 120px;
  /* Footer 高度的负值 */
}

.head-img-box {
  background-color: #fff;
}

.head-img {
  width: 80%;
  margin: 0 auto;
  display: block;
}

.company {
  padding-bottom: 0.5rem;
  background-color: #fff;
}

.grid {
  display: flex;
  margin-top: 0.25rem;
  flex: 1;
  background-color: #fff;

  /deep/ .van-grid-item__content {
    padding: 0 !important;
  }
}

.grid-item-label {
  font-size: 14px;
  font-weight: bold;
}
</style>
